var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[_c('p',{staticClass:"timeline-title"},[_vm._t("university")],2),_vm._v(" "),_c('p',{staticClass:"timeline-date"},[_vm._t("date")],2),_vm._v(" "),_c('p',[_vm._t("course")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1845b184","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/Timeline.vue
// module id = null
// module chunks = 